<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px" class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item :label="$t('quoteByLine.sourcing.sourcingNo')" prop="sourcingNo">
                    <el-input class="handle-input" v-model="queryCondition.sourcingNo" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('quoteByLine.sourcing.subject')" prop="subject">
                    <el-input class="handle-input" v-model="queryCondition.subject" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('quoteByLine.sourcing.applyType')" prop="applyType">
                    <el-select v-model="queryCondition.applyType" class="handle-input" clearable style="width:100%">
                      <el-option :label="$t('common.all')" value></el-option>
                      <el-option :key="index" v-for="(item,index) in applyTypeList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('quoteByLine.sourcing.quotationType')" prop="quotationType">
                    <el-select v-model="queryCondition.quotationType" class="handle-input" clearable style="width:100%">
                      <el-option :label="$t('common.all')" value></el-option>
                      <el-option :key="index" v-for="(item,index) in quotationTypeList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-collapse-transition>
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item :label="$t('quoteByLine.sourcing.supplierCode')" prop="supplierCode">
                      <el-input clearable class="handle-input" suffix-icon="el-icon-search" @click.native="showSelSupplierDialog=true;SupplierNameDialogReset = true" v-model="queryCondition.supplierCode" @clear="clearSupplierName" style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item :label="$t('quoteByLine.sourcing.applyNo')" prop="applyNo">
                      <el-input class="handle-input" v-model="queryCondition.applyNo" clearable style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item :label="$t('common.createBy')" prop="createUserName">
                      <el-input class="handle-input" v-model="queryCondition.createUserName" clearable style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item :label="$t('common.status')" prop="status">
                      <ic-select clearable table="TT_SOURCING" class="handle-input" field="STATUS" v-model="queryCondition.status" style="width:100%"></ic-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="创建日期(从)" prop="createDateStart" clearable>
                      <el-date-picker value-format="yyyy-MM-dd" v-model="queryCondition.createDateStart" type="date" :placeholder="$t('common.selDate')" style="width:100%"></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="创建日期(至)" prop="createDateEnd" clearable>
                      <el-date-picker value-format="yyyy-MM-dd" v-model="queryCondition.createDateEnd" type="date" :placeholder="$t('common.selDate')" style="width:100%"></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="审核日期(从)" prop="auditDateStart" clearable>
                      <el-date-picker value-format="yyyy-MM-dd" v-model="queryCondition.auditDateStart" type="date" :placeholder="$t('common.selDate')" style="width:100%"></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="审核日期(至)" prop="auditDateEnd" clearable>
                      <el-date-picker value-format="yyyy-MM-dd" v-model="queryCondition.auditDateEnd" type="date" :placeholder="$t('common.selDate')" style="width:100%"></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item :label="$t('quoteByLine.sourcing.auditor')" prop="auditor">
                      <el-input class="handle-input" v-model="queryCondition.auditor" clearable style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-collapse-transition>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="queryData(1)" type="primary">{{$t('common.search')}}</el-button>
            <el-button size="mini" @click="restQueryForm" type="primary">{{$t('common.reset')}}</el-button>
            <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button size="mini" class="btn" type="primary" v-acl="SourcingSendSourcingMail" @click="sendSourcingMail()">发送中标通知</el-button>
      </el-row>
      <el-table :data="tableData" ref="tableData" border max-height="550" highlight-current-row row-key="ttSourcingLineId">
        <el-table-column fixed sortable type="selection" width="55" align="center" :reserve-selection="true"></el-table-column>
        <el-table-column show-overflow-tooltip fixed sortable prop="sourcingNo" align="center" :label="$t('quoteByLine.sourcing.sourcingNo')" min-width="140px">
          <template slot-scope="scope">
            <el-link type="primary" @click="querySourcingLine(scope.row.sourcingNo)">{{scope.row.sourcingNo}}</el-link>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip fixed sortable prop="applyNo" align="center" :label="$t('quoteByLine.sourcing.applyNo')" min-width="130px">
          <template slot-scope="scope">
            <el-link type="primary" @click="openQuotationApplyDetail(scope.row)">{{scope.row.applyNo}}</el-link>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="applyTypeI18n" align="center" :label="$t('quoteByLine.sourcing.applyType')" min-width="80px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="subject" align="center" :label="$t('quoteByLine.sourcing.subject')" min-width="120px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="quotationTypeI18n" align="center" :label="$t('quoteByLine.sourcing.quotationType')" min-width="100px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="supplierCode" align="center" :label="$t('quoteByLine.sourcing.supplierCode')" min-width="100px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="supplierName" align="center" :label="$t('quoteByLine.sourcing.supplierName')" min-width="100px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="pickupPoint" align="center" :label="$t('quoteByLine.sourcing.pickupPoint')" min-width="80px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="dcName" align="center" :label="$t('quoteByLine.sourcing.dc')" min-width="90px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="temperatureI18n" align="center" :label="$t('quoteByLine.sourcing.temperature')" min-width="80px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="transportaionMethodI18n" align="center" :label="$t('quoteByLine.sourcing.transportaionMethod')" min-width="90px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="lineType" align="center" :label="$t('apply.lineType')" min-width="90px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="statusI18n" align="center" :label="$t('common.status')" min-width="80px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="auditor" align="center" :label="$t('quoteByLine.sourcing.auditor')" min-width="120px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="createUserName" align="center" :label="$t('common.createBy')" min-width="120px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="createDate" align="center" :label="$t('common.createDate')" min-width="100px">
          <template slot-scope="scope">{{scope.row.createDate | dateFormatFilter("YYYY-MM-DD")}}</template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
      </div>
    </div>
    <el-dialog :visible.sync="showSelSupplierDialog" append-to-body width="80%">
      <SelSupplier ref="supplierSelRef" v-if="SupplierNameDialogReset" @subCallMethod="selectSupplierMethod"></SelSupplier>
    </el-dialog>
  </div>
</template>
<script>
import { search, sendSourcingMail } from "../../../api/line/sourcing";
import sourcingApi from "@/api/line/sourcing";
import IcSelect from "@/components/common/icSelect";
import { inputChoiceService } from "../../../api/common/input-choice";
import { Message } from "element-ui";
import SelSupplier from "../base-data/carrier-sel-page";
import DateRanger from "@/components/common/dateRanger";
import store from '@/store/index'
import paginationMixin from '../../../mixins/pagitionMixin';
import commonFunction from "../../../utils/dataTableUtils"

export default {
  name: "sourcing",
  mixins: [paginationMixin],
  components: {
    DateRanger,
    SelSupplier, IcSelect
  },

  data() {
    return {
      isShow: false,//控制查询列表收缩展开
      SupplierNameDialogReset: false,
      tableData: [],
      totalCount: 0,
      labelPosition: "right",

      //选择承运商
      showSelSupplierDialog: false,
      //选择承运商

      //下拉列表数据
      quotationTypeList: [],
      applyTypeList: [],
      //下拉列表数据
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        sourcingNo: "",
        subject: "",
        auditor: "",
        applyType: "",
        quotationType: "",
        supplierCode: "",
        applyNo: "",
        createUserName: "",
        status: '',
        createDateStart: "",
        createDateEnd: "",
        auditDateStart: "",
        auditDateEnd: "",
        supplierCode: "",
        auditor: "",
        tmSupplierIds: [],
      },
    };
  },
  created() {
    // this.queryData(1);
    this.getInputChoiceValues();
  },
  watch: {
    queryCondition() {
      let _this = this;
      store.dispatch('uploadListParams', { routeName: _this.$route.name, reqData: _this.queryCondition })
    }
  },
  beforeRouteEnter(to, from, next) {
    search(to.meta.reqData).then((res) => {
      next(vm => {
        vm.queryCondition = to.meta.reqData;
        vm.tableData = res.resultData;
        vm.totalCount = res.totalCount;
      })
    })
  },
  methods: {
    //查询报价确认数据
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      search(this.queryCondition).then(res => {
        this.tableData = res.resultData;
        this.totalCount = res.totalCount;
      });
    },

    //查询报价确认明细
    querySourcingLine(sourcingNo) {
      //this.sourcingNo = sourcingNo;
      //this.$router.replace({name:'sourcingDetail',params: {sourcingNo:sourcingNo}});
      this.$router.push({
        path: "/sourcing-detail",
        query: { sourcingNo: sourcingNo }
      });
    },

    //选择承运商
    selectSupplierMethod: function (supList) {
      this.queryCondition.tmSupplierIds = [];
      this.queryCondition.supplierCode = "";
      supList.forEach(item => {
        this.queryCondition.tmSupplierIds.push(item.tmSupplierId);
        this.queryCondition.supplierCode =
          this.queryCondition.supplierCode + item.supplierCode + ",";
      });
      this.queryCondition.supplierCode = supList
        .map(sup => sup.supplierCode)
        .join(",");

      this.showSelSupplierDialog = false;
    },

    //发送邮件
    sendSourcingMail: function () {
      let rows = this.$refs.tableData.selection;
      if (rows.length == 0) {
        //请选择需要发送中标通知书的数据
        Message({
          message: this.$t("quoteByLine.sourcing.selSendMailData"),
          type: "warning"
        });
        return;
      }

      //选择数据包含未通过审核数据
      for (let i = 0; i < rows.length; i++) {
        if (rows[i].status != "COMPLETE") {
          Message({
            message: this.$t("quoteByLine.sourcing.unqualifiedData"),
            type: "warning"
          });
          return;
        }
      }

      //确定发送报价确认邮件
      this.$confirm(
        this.$t("quoteByLine.sourcing.confirmSendMail"),
        this.$t("common.tips"),
        {
          confirmButtonText: this.$t("common.confirm"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        }
      ).then(() => {
        sendSourcingMail(rows).then(res => {
          console.log(res);
          if (res.totalCount > 0) {
            //发送邮件失败
            Message({
              message:
                res.resultData + this.$t("quoteByLine.sourcing.sendMailFailed"),
              type: "warning"
            });
          } else {
            Message({
              message: this.$t("quoteByLine.sourcing.sendMailSuccess"),
              type: "success"
            });
          }
        });
      });
    },

    //查询申请单明细
    openQuotationApplyDetail: function (row) {
      if (this.actionCheck.actionCheck("ApplyInfo") === false) {
        this.$message.error(this.$t("common.noPermission"));
        return false;
      }
      this.$router.replace({
        name: "applyDetail",
        params: { applyId: row.ttQuotationApplyId, source: "sourcing" }
      });
    },

    //获取下拉列表数据
    getInputChoiceValues() {
      let mapObj = {};
      mapObj["TT_QUOTATION_APPLY:QUOTATION_TYPE"] =
        "TT_QUOTATION_APPLY:QUOTATION_TYPE";
      mapObj["TT_QUOTATION_APPLY:APPLY_TYPE"] = "TT_QUOTATION_APPLY:APPLY_TYPE";
      inputChoiceService.getInputChoiceValues(mapObj).then(res => {
        this.quotationTypeList = res["TT_QUOTATION_APPLY:QUOTATION_TYPE"];
        this.applyTypeList = res["TT_QUOTATION_APPLY:APPLY_TYPE"];
      });
    },

    // //分页查询页数变化
    // pageNumberChange(val) {
    //   this.queryCondition.pageNum = val;
    //   this.queryData();
    // },
    // //分页查询每页显示数量变化
    // pageSizeChange(val) {
    //   this.queryCondition.pageSize = val;
    //   this.queryData();
    // },
    //查询条件重置方法
    restQueryForm: function () {
      this.$refs.queryCondition.resetFields();
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        sourcingNo: "",
        subject: "",
        auditor: "",
        applyType: "",
        quotationType: "",
        supplierCode: "",
        applyNo: "",
        createUserName: "",
        status: '',
        createDateStart: "",
        createDateEnd: "",
        auditDateStart: "",
        auditDateEnd: "",
        supplierCode: "",
        auditor: "",
        tmSupplierIds: [],
      }
      this.$refs.tableData.clearSelection();
      this.queryData();
    },
    clearSupplierName() {
      this.SupplierNameDialogReset = false
      this.queryCondition.tmSupplierIds = [];
      this.$nextTick(() => {
        this.SupplierNameDialogReset = true
      })
    },
    submit(sourcingId) {
      sourcingApi.startNewTask(sourcingId).then(data => {
        console.log(data);
      });
    }
  },
  extends: commonFunction
};
</script>
<style scoped  lang="scss">
.query-btn-row {
  width: 30%;
  float: right;
}
.dialog-input {
  width: 40%;
}
.el-select {
  width: 100%;
}
</style>
<style lang="scss">
.sourcing {
  .flexBox {
    .el-form-item__content {
      display: -moz-box; /* Firefox */
      display: -ms-flexbox; /* IE10 */
      display: -webkit-box; /* Safari */
      display: -webkit-flex; /* Chrome, WebKit */
      display: flexbox;
      display: flex;
      display: flex !important;
    }
  }
}
</style>

